export default {
  name: 'SmsServiceCommon',

  computed: {
    smsServiceActive() {
      return this.AppSmsService?.Active ?? false
    },

    smsServiceCharge() {
      return this.AppSmsService?.Charge ?? null
    },

    smsServiceChargePrice() {
      return this.AppSmsService?.Charge?.Price ?? 0
    },

    smsServiceExtraFields() {
      return this.AppSmsService?.ExtraFields ?? null
    }
  },

  methods: {}
}
